import { localeOf } from "./locale.js";
import { formatMoney } from "./money.js";
import { itemPriceOf, itemWishText } from "./public-item.js";
import { PROFILE_WHATSAPP_GREETING } from "./public-shop-view.js";
/**
 * WHAT AN ITEM'S PAGE SAYS (on the web and on the phone), as
 * plain functions both clients draw from.
 */
/**
 * The «Escribir por WhatsApp» message, naming the item and the variant
 * chosen. An item of a published profile is a page of that profile, so it
 * greets as the profile does; a link the business sent alone
 * keeps its own «Hola, me interesa …».
 */
export function itemWhatsappText(view, variantName) {
    const about = itemWishText(view.item.name, variantName);
    return view.business.shopSlug === null ? `Hola, me interesa ${about}` : `${PROFILE_WHATSAPP_GREETING} Me interesa ${about}.`;
}
/**
 * The price the page announces, and the unit it is sold by (null without
 * one): the chosen variant's, or -- none chosen yet -- «Desde» the cheapest
 * when the prices differ (`itemPriceOf`), the one price when they do not.
 * `price` is empty without a variant: nothing to announce.
 */
export function itemPriceParts(view, chosen) {
    const locale = localeOf(view.business.country);
    const variant = chosen === null ? undefined : view.item.variants[chosen];
    const announced = variant === undefined ? itemPriceOf(view.item.variants) : { cents: variant.priceCents, from: false };
    const unit = view.item.saleUnit?.trim() ?? "";
    return {
        from: announced?.from ?? false,
        price: announced === null ? "" : formatMoney(announced.cents, locale),
        unit: unit === "" ? null : unit,
    };
}
